//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { QueryKeyConstants } from '@queries/QueryKeyConstants';

// Grpoups of keys that are always used together to make referencing specific queries consistent
export const SchedulerKeyGroupings = {
  SchedulingUpsertDraftsMutation: [
    QueryKeyConstants.Scheduling,
    QueryKeyConstants.SchedulingUpsertDrafts,
  ],
  SchedulingDeleteDraftsMutation: [
    QueryKeyConstants.Scheduling,
    QueryKeyConstants.SchedulingDeleteDrafts,
  ],
  SchedulingDeleteScheduledPostsMutation: [
    QueryKeyConstants.Scheduling,
    QueryKeyConstants.SchedulingDeleteScheduledPosts,
  ],
  SchedulingUpsertScheduledPostsMutation: [
    QueryKeyConstants.Scheduling,
    QueryKeyConstants.ScheduledingUpsertScheduledPosts,
  ],
  SchedulingFeedPreviewScheduledInstagramPosts: [
    QueryKeyConstants.Scheduling,
    QueryKeyConstants.SchedulingGetFeedPreviewInstagramScheduledPosts,
  ],
} as const;
